import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    width: '100%',
    backgroundColor: cloudLight,
  },
  fill: {
    width: '0%',
    height: '100%',
  },
});

export const variants = StyleSheet.create({
  defaultBase: {
    height: 6,
    borderRadius: 2,
  },
  defaultFill: {
    borderRadius: 2,
  },
  thinBase: {
    height: 2,
    borderRadius: 0,
  },
  thinFill: {
    borderRadius: 0,
  },
});
